// extracted by mini-css-extract-plugin
export default {"root":"_2huUr","align-items-center":"_13Omr","alignItemsCenter":"_13Omr"};